import React, {Component} from "react";
import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import Alert from "react-s-alert";
import Select from "../../local_node_modules/react-select";
import Tree, {TreeNode} from "rc-tree";
import cssAnimation from "css-animation";
import ReactLoading from "react-loading";
import NavBarKS from "../../components/NavBarKS";
import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import {showBaro} from "../../helper/permission";
import {VirtualHost} from "../../constants";
import {serviceTypeEnum} from "../../helper/enums";

function animate(node, show, done) {
    let height = node.offsetHeight;
    return cssAnimation(node, 'collapse', {
        start() {
            if (!show) {
                node.style.height = `${node.offsetHeight}px`;
            } else {
                height = node.offsetHeight;
                node.style.height = 0;
            }
        },
        active() {
            node.style.height = `${show ? height : 0}px`;
        },
        end() {
            node.style.height = '';
            done();
        },
    });
}

const animation = {
    enter(node, done) {
        return animate(node, true, done);
    },
    leave(node, done) {
        return animate(node, false, done);
    },
};

class CustomizeExcel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            treeData:[],
            checkedKeys:[],
            data:[],
            type: (showBaro() || VirtualHost.conf.resourcePrefix === "turkkep" ? 'SERBESTMESLEKMAKBUZ:archive_voucher' :
                (VirtualHost.conf.resourcePrefix === "faturam24" ? "EARSIV5BINOTUZBIN:tmp_doc_belge" : 'INVOICE:inbox')),
            name:'',
            recordId:null,
            disable:false,
            autoExpandParent: false,
            typeList:[{
                label:'e-Fatura Gelen',
                value:'INVOICE:inbox',
                serviceId:2
            },{
                label: 'e-Fatura Giden',
                value: 'INVOICE:outbox',
                serviceId:serviceTypeEnum.E_FATURA
            },{
                label: 'e-Fatura Gelen Transfer',
                value: 'INVOICETRANSFER:inbox_transfer',
                serviceId:serviceTypeEnum.E_FATURA
            },{
                label: 'e-Fatura Giden Transfer',
                value: 'INVOICETRANSFER:outbox_transfer',
                serviceId:serviceTypeEnum.E_FATURA
            },{
                label: 'e-Arşiv Fatura',
                value: 'EARSIVFATURA:archive_invoice',
                serviceId:serviceTypeEnum.E_ARSIV
            },{
                label: 'e-Arşiv Transfer Fatura',
                value: 'EARSIVTRANSFERFATURA:archive_invoice_transfer',
                serviceId:serviceTypeEnum.E_ARSIV
            }, {
                label: 'Tüm Giden Faturalar',
                value: 'ALLINVOICE:outbox-archive_invoice',
                serviceId:serviceTypeEnum.E_FATURA
            },{
                label: 'e-Serbest Meslek Makbuz',
                value: 'SERBESTMESLEKMAKBUZ:archive_voucher',
                serviceId:serviceTypeEnum.SMM
            },{
                label: 'e-Müstahsil Makbuz',
                value: 'MUSTAHSILMAKBUZ:archive_voucher',
                serviceId:serviceTypeEnum.MM
            },{
                label:'e-Gider Pusulası',
                value:'GIDERPUSULASI:egiderpusulasi',
                serviceId:serviceTypeEnum.E_GIDER_PUSULASI
            },{
                label:'e-İrsaliye Gelen',
                value:'DESPATCHADVICE:inbox',
                serviceId:serviceTypeEnum.E_IRSALIYE
            },{
                label:'e-İrsaliye Giden',
                value:'DESPATCHADVICE:outbox',
                serviceId:serviceTypeEnum.E_IRSALIYE
            },{
                label:'e-Arşiv Belge',
                value:'EARSIV5BINOTUZBIN:tmp_doc_belge',
                serviceId:serviceTypeEnum.E_ARSIV_BES_BIN_OTUZ_BIN
            },{
                label:'e-Döviz Belge',
                value:'EXCHANGE:exchange',
                serviceId:serviceTypeEnum.E_DOVIZ
            },{
                label:'e-Adisyon Belge',
                value:'ADISYON:receipt',
                serviceId:serviceTypeEnum.E_ADISYON
            },(VirtualHost.conf.resourcePrefix === "kolaysoft" || VirtualHost.conf.resourcePrefix === "eczacikart") &&
                {
                    label: 'EczacıPos Faturalar',
                    value: 'ECZACIPOS:outbox-archive_invoice',
                    serviceId: serviceTypeEnum.E_FATURA
                }],
            updatedAt: null,
            createdAt: null,
        };
        this.getList    = this.getList.bind(this);
        this.save       = this.save.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.onCheck    = this.onCheck.bind(this);
        this.fetchAll   = this.fetchAll.bind(this);
        this.createCustomerHeaderExcel  = this.createCustomerHeaderExcel.bind(this);
        this.convertChildrenToArray     = this.convertChildrenToArray.bind(this);

    }

    componentWillMount() {
        if(showBaro() || VirtualHost.conf.resourcePrefix === "turkkep"){
            let typeList = this.state.typeList;
            typeList = typeList.filter(t=>t.serviceId === serviceTypeEnum.SMM || t.serviceId === serviceTypeEnum.MM);
            this.setState({typeList:typeList});
        } else if(VirtualHost.conf.resourcePrefix === "faturam24") {
            let typeList = this.state.typeList;
            typeList = typeList.filter(t=>t.serviceId === serviceTypeEnum.E_ARSIV_BES_BIN_OTUZ_BIN);
            this.setState({typeList:typeList});
        }

        this.getList();
        this.fetchAll();
    }

    fetchAll(){
        let self = this;
        self.setState({loadingList:true});
        request({
            url: `/excelXpath/fetchAll`,
            method: 'post'
        }).then(response => {
            let data = response.data;
            self.setState({data, loadingList:false})
        }).catch(error => {
            showAxiosError(error);
            self.setState({loadingList:false});
        });
    }

    getList(){
        let self = this;
        let {type} = self.state;
        self.setState({loading:true, treeData:[], checkedKeys:[],recordId:null});
        request({
            url: `/excelXpath/getList`,
            method: 'post',
            data:type.split(':')[0]
        }).then(response => {
            let data = response.data;
            let treeData = data.treeData;
            let checkedKeys = data.checkedKeys;
            for (let index in treeData) {
                self.convertChildrenToArray(treeData, index);
            }
            self.setState({treeData, checkedKeys,loading:false, name:'',selectedItem:null})
        }).catch(error => {
            showAxiosError(error);
            self.setState({loading:false});
        });
    }

    convertChildrenToArray(treeData, element){
        if (treeData[element] && treeData[element]["children"]) {
            treeData[element]["children"] = Object.values(treeData[element]["children"])
            for (let index in treeData[element]["children"]) {
                this.convertChildrenToArray(treeData[element]["children"], index);
            }
        }
    }

    createCustomerHeaderExcel(){
        let {name,type,recordId,treeData,createdAt,updatedAt} = this.state;
        let customerExcelHeaderChildList=[];
        let order1 = 1;
        for (let i=0;i< treeData.length; i++) {
            let index = treeData[i];
            customerExcelHeaderChildList.push({
                listExcelHeaderId: index.recordId,
                order:order1++,
                parentId:index.parentId,
                selected:index.defaultSelected,
                customerExcelHeader:{
                    recordId:recordId
                }
            });

            if(index.children && index.children.length>0){
                let order2 = 1;
                for (let i=0;i< index.children.length; i++) {
                    let child = index.children[i];
                    customerExcelHeaderChildList.push({
                        listExcelHeaderId: child.recordId,
                        order:order2++,
                        parentId:child.parentId,
                        selected:child.defaultSelected,
                        customerExcelHeader:{
                            recordId:recordId
                        }
                    });
                }
            }
        }
        return {
            recordId:recordId,
            name:name,
            reportType:type.split(':')[1],
            documentType:type.split(':')[0],
            updatedAt: updatedAt,
            createdAt: createdAt,
            customerExcelHeaderChildList:customerExcelHeaderChildList
        }
    }

    handleDelete() {
        let self = this;
        self.setState({disabledBtn:true});
        request({
            url: `/excelXpath/delete`,
            method: 'post',
            data:self.state.selectedItem.recordId
        }).then(response => {
            Alert.success(response.data, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 1000
            });
            self.setState({
                selectedItem:null,
                showSwal:false,
                disabledBtn:false,
                type:'INVOICE:.inbox',
                name:'',
                recordId:null
            },()=>this.fetchAll());
        }).catch(error => {
            showAxiosError(error);
            self.setState({disabledBtn:false});
        });
    }

    handleEdit(row) {
        let self = this;
        self.setState({loading:true, treeData:[], checkedKeys:[], selectedItem:row});
        request({
            url: `/excelXpath/edit`,
            method: 'post',
            data:row.recordId
        }).then(response => {
            let data = response.data;
            let treeData  = data.treeData;
            let name      = data.name;
            let updatedAt = data.updatedAt;
            let createdAt = data.createdAt;
            let recordId      = row.recordId;
            let type= data.documentType+":"+data.reportType;
            console.log("treeData4",treeData);
            let checkedKeys = data.checkedKeys;
            for (let index in treeData) {
                self.convertChildrenToArray(treeData, index);
            }
            self.setState({treeData, checkedKeys,loading:false, name, type,recordId, createdAt, updatedAt})
        }).catch(error => {
            showAxiosError(error);
            self.setState({loading:false, selectedItem:null});
        });
    }

    save() {
        this.setState({
            createdAt: ""
        })
        let self = this;
        let {name,type,checkedKeys,treeData} = self.state;
        let valid = name && type && checkedKeys && checkedKeys.length>0;
        if (valid) {
            console.log("treeData2",treeData);
            let params = {
                url: `/excelXpath/save`,
                method: 'post',
                data: self.createCustomerHeaderExcel()
            };
            self.setState({disable:true});
            request(params)
            .then(response => {
                Alert.success(response.data, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 1000
                });
                self.setState({disable: false}, ()=>{this.getList(); this.fetchAll()});
            }).catch(error => {
                self.setState({disable: false});
                showAxiosError(error);
            });
        }else{
            let message = "";
            if(!type)
                message = message +  "Rapor Türü alanı boş bırakılamaz";

            if(!name)
                message = message +  "Rapor Adı alanı boş bırakılamaz";

            if(!(checkedKeys && checkedKeys.length>3))
                message = message +  "En az 3 Rapor başlığı seçilmelidir.";

            Alert.error(message, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
        }
    }

    onDragStart = info =>{
        //console.log('start', info);
    };

    onDragEnter = info =>{
        this.setState({expandedKeys: info.expandedKeys});
    };

    onDrop = info => {
        const dropKey = info.node.props.eventKey;
        const dragKey = info.dragNode.props.eventKey;
        const dropPos = info.node.props.pos.split('-');
        const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

        const loop = (data, key, callback) => {
            data.forEach((item, index, arr) => {
                if (item.key === key) {
                    callback(item, index, arr);
                    return;
                }
                if (item.children) {
                    loop(item.children, key, callback);
                }
            });
        };
        const data = deepCopyObject(this.state.treeData);
        if(!info.dropToGap)
            return;
        // Find dragObject
        let dragObj;
        loop(data, dragKey, (item, index, arr) => {
            arr.splice(index, 1);
            dragObj = item;
        });

        if (!info.dropToGap) {
            /*loop(data, dropKey, item => {
                item.children = item.children || [];
                item.children.push(dragObj);
            });*/
        } else if ((info.node.props.children || []).length > 0 &&
            info.node.props.expanded && dropPosition === 1) {
            loop(data, dropKey, item => {
                item.children = item.children || [];
                item.children.unshift(dragObj);
            });
        } else {
            let ar;
            let i;
            loop(data, dropKey, (item, index, arr) => {
                ar = arr;
                i = index;
            });

            if(ar && ar.length>0 && ar[0].parentId === dragObj.parentId){
                if (dropPosition === -1) {
                    ar.splice(i, 0, dragObj);
                } else {
                    ar.splice(i + 1, 0, dragObj);
                }
                this.setState({treeData: data});
            }
        }
    };

    onCheck(checkedKeys, info) {
        let halfCheckedKeys = info.halfCheckedKeys;
        let pos     = info.node.props.pos;
        let checked = info.checked;
        let treeData = this.state.treeData;

        let res = pos.split("-");
        console.log("res",res);

        if(res.length===2){
            treeData[res[1]].defaultSelected=checked;
            if(treeData[res[1]].children && treeData[res[1]].children.length>0){
                for (let i=0;i< treeData[res[1]].children.length; i++) {
                    treeData[res[1]].children[i].defaultSelected = checked;
                }
            }
        }

        if(res.length===3){
            treeData[res[1]].children[res[2]].defaultSelected=checked;
        }
        this.setState({checkedKeys, halfCheckedKeys,treeData})
    }

    onExpand = expandedKeys => {
        //console.log('onExpand', expandedKeys);
        this.setState({expandedKeys, autoExpandParent: false});
    };

    getReportType(item){
        let reportType = item.reportType.split(".")[1];
        return (reportType ==="outbox" || reportType.indexOf("outbox_")!==-1) ? "Giden Fatura" : (reportType ==="inbox" || reportType.indexOf("inbox_")!==-1 ? "Gelen Fatura" :item.documentType);
    }

    render() {
        let {treeData, checkedKeys, selectedKeys, loading,loadingList,selectedItem} = this.state;
        const loop = data =>
            data.map(item => {
                if (item.children && item.children.length) {
                    return (
                        <TreeNode key={item.key} title={item.title}>
                            {loop(item.children)}
                        </TreeNode>
                    );
                }
                return <TreeNode key={item.key} title={item.title} />;
            });
        return (
            <Col className="row baseBackground">
                <NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}
                          btnDisabled={this.state.btnDisabled} name={this.props.name}
                          selection={this.state.selection}>
                </NavBarKS>
                <Col sm={12} className="satirBasi">
                    <Col className="card-header">
                        <h4 className="card-title">Rapor Özelleştirme</h4>
                    </Col>
                    <Col sm={12} className="card-body">
                        <Row style={{paddingLeft:0, margin:"0px"}} className="baseDashboard">
                            <React.Fragment>
                                <Col sm={6} style={{paddingTop:'10px', overflow:'auto', height: '800px'}}>
                                    <Row>
                                        <Col sm={6}>
                                            <FormGroup row>
                                                <Label sm={10} for="type" style={{fontWeight:'bold'}}>Rapor Türü: </Label>
                                                <Col sm={12}>
                                                    <Select
                                                        name="type"
                                                        clearable={false}
                                                        searchable={false}
                                                        value={this.state.type}
                                                        onChange={e => {this.setState({type: e.value}, () => this.getList())}}
                                                        options={this.state.typeList}
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                        <Col sm={6}>
                                            <FormGroup row>
                                                <Label sm={10} for="name" style={{fontWeight:'bold'}}>Rapor Adı: </Label>
                                                <Col sm={12}>
                                                    <Input type="text"
                                                           maxLength={45}
                                                           name="name"
                                                           value={this.state.name}
                                                           onChange={(e) => this.setState({name:e.target.value})}/>
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                        <Col sm={6}>
                                            {loading &&
                                                <ReactLoading type="spinningBubbles" style={{
                                                    width: "40px",
                                                    height: "40px",
                                                    margin: "20px auto 0 auto",
                                                    fill: "#888"
                                                }}/>
                                            }
                                            {!loading &&
                                            <FormGroup row>
                                                <Label sm={10} for="type" style={{fontWeight:'bold'}}>Rapor Başlıkları: </Label>
                                                <Col sm={12}>
                                                    <Tree
                                                        openAnimation={animation}
                                                        showLine
                                                        draggable
                                                        checkable
                                                        selectable={false}
                                                        defaultExpandAll
                                                        expandedKeys={this.state.expandedKeys}
                                                        onExpand={this.onExpand}
                                                        autoExpandParent={this.state.autoExpandParent}
                                                        onCheck={this.onCheck}
                                                        selectedKeys={selectedKeys}
                                                        checkedKeys={checkedKeys}
                                                        onDragStart={this.onDragStart}
                                                        onDragEnter={this.onDragEnter}
                                                        onDrop={this.onDrop}
                                                    >
                                                        {loop(treeData)}
                                                    </Tree>
                                                </Col>
                                            </FormGroup>
                                            }
                                        </Col>
                                        <Col sm={6}>
                                            <Row style={{margin:"0px"}}>
                                                <Col sm={6} style={{padding:0}}>
                                                    <Button color="default" size="sm" disabled={this.state.disable} block onClick={()=>this.getList()}>Temizle</Button>
                                                </Col>
                                                <Col sm={6} style={{padding:'0px 0px 0px 6px'}}>
                                                    <Button color="info" size="sm" disabled={this.state.disable} block onClick={()=>this.save()}>Kaydet</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                                <hr></hr>
                                <Col sm={6} className="row" style={{overflow: 'auto', height: '800px'}}>
                                    <Col sm={12} style={{paddingTop:'10px'}}>
                                        <FormGroup row>
                                            <Label sm={10} for="type" style={{fontWeight:'bold'}}>Rapor Özelleştirme Listesi: </Label>
                                            <Col sm={12}>
                                                <table className="" style={{textAlign: 'center'}}>
                                                    <thead>
                                                    <tr style={{backgroundColor: '#ebedf0'}}>
                                                        <th width="4%">#</th>
                                                        <th width="20%">Rapor Adı</th>
                                                        <th width="20%">Rapor Türü</th>
                                                        <th width="22%">Oluşturulma Zamanı</th>
                                                        <th width="22%">Güncellenme Zamanı</th>
                                                        <th width="12%">İşlemler</th>
                                                    </tr>
                                                    </thead>
                                                    {loadingList &&
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan={6}>
                                                                    <ReactLoading type="spinningBubbles" style={{width:"40px", height: "40px", margin: "20px auto 20px auto", fill: "#888"}}/>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    }
                                                    {!loadingList &&
                                                        <tbody>{
                                                            this.state.data.map((data, index) =>
                                                                <tr key={index}  style={{backgroundColor:(selectedItem && (selectedItem.recordId === data.recordId) ? "lightgreen" :"")}}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{data.name}</td>
                                                                    <td>{(data.hasLine ? "Satırlı" : "Satırsız")}<br/>{this.getReportType(data)}</td>
                                                                    <td>{moment(data.createdAt).isValid() ? moment(data.createdAt).format("DD-MM-YYYY HH:mm:ss") : ''}</td>
                                                                    <td>{moment(data.updatedAt).isValid() ? moment(data.updatedAt).format("DD-MM-YYYY HH:mm:ss") : ''}</td>
                                                                    <td style={{margin:0}}>
                                                                        <Row>
                                                                            <Col sm={12}>
                                                                                <button type="button"
                                                                                        onClick={() => this.handleEdit(data)} rel="tooltip"
                                                                                        className="btn btn-info btn-sm btn-icon "
                                                                                        style={{margin: "0",background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}>
                                                                                    <i className="fa fa-edit"></i>
                                                                                </button>
                                                                                <button type="button" onClick={() => this.setState({selectedItem : data, showSwal:true})} rel="tooltip"
                                                                                        className="btn btn-danger btn-sm btn-icon "
                                                                                        style={{margin: "0", background: '#FFCCCC'}}>
                                                                                    <i className="fa fa-trash"></i>
                                                                                </button>
                                                                            </Col>
                                                                        </Row>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    }
                                                </table>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Col>
                            </React.Fragment>
                        </Row>
                    </Col>
                </Col>
                {this.state.showSwal &&
                    <SweetAlert showCancel warning
                                disabled={this.state.disabledBtn}
                                confirmBtnText="Evet"
                                cancelBtnText="Hayır"
                                confirmBtnBsStyle="danger"
                                cancelBtnBsStyle="default"
                                title="Emin misiniz?"
                                onConfirm={this.handleDelete}
                                onCancel={() => this.setState({showSwal: false})}>
                        {this.state.selectedItem.name} rapor özelleştirmesi silinecek..! Onaylıyor musunuz ?
                    </SweetAlert>
                }
            </Col>
        );
    }
}

export default CustomizeExcel;